import { render, staticRenderFns } from "./editor-modal.vue?vue&type=template&id=02843680&"
import script from "./editor-modal.vue?vue&type=script&lang=js&"
export * from "./editor-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports